import { useQuery } from 'react-query';

import { api } from '../api';

// Primeira página na Phoebus: a resposta de /v3/payments traz `page: 0`, mas os
// exemplos da doc pedem `page=1`. Confirmar na primeira chamada real e ajustar aqui.
export const PHOEBUS_FIRST_PAGE = 0;

// Transação como a Phoebus devolve (sem taxas nem tratamento). Só os campos
// usados na tela; o resto do JSON cru segue disponível no objeto.
export interface IPagamentoPhoebus {
  uuid?: string;
  nsu?: number;
  acquirer_nsu?: string;
  authorization_number?: string;
  card_number?: string;
  brand?: string;
  product_name?: string;
  parcels?: number;
  // em centavos (517 = R$ 5,17)
  value?: number;
  status?: number;
  terminal?: string;
  merchant?: string;
  start_date?: string;
  [key: string]: unknown;
}

interface IRespostaMerchant {
  merchant: string;
  page: number;
  total_pages: number;
  total_elements: number;
  size: number;
  content: IPagamentoPhoebus[];
}

interface IParams {
  docto: string;
  data: string;
  pagina: number;
  limite: number;
}

interface GetTransacoesTempoRealResult {
  transactions: IPagamentoPhoebus[];
  total: number;
  hasNextPage: boolean;
}

export async function getTransacoesTempoReal(
  params: IParams
): Promise<GetTransacoesTempoRealResult> {
  const { data } = await api.get<IRespostaMerchant[]>(
    'transactions/transacao-tempo-real',
    {
      params: {
        ...params,
        // o front pagina a partir de 1
        pagina: params.pagina - 1 + PHOEBUS_FIRST_PAGE,
      },
    }
  );

  return {
    transactions: data.flatMap((merchant) => merchant.content ?? []),
    total: data.reduce((sum, merchant) => sum + (merchant.total_elements ?? 0), 0),
    hasNextPage: data.some((merchant) => params.pagina < merchant.total_pages),
  };
}

export function useTransacoesTempoReal(params: IParams) {
  return useQuery(
    [
      'transacoes-tempo-real',
      params.docto,
      params.data,
      params.pagina,
      params.limite,
    ],
    () => getTransacoesTempoReal(params),
    {
      // tempo real: não reaproveitar o cache como nas telas D+1
      staleTime: 0,
      enabled:
        String(api.defaults.headers.common.authorization).length > 10 &&
        !!params.docto &&
        !!params.data,
      retry: 1,
    }
  );
}
